import { useTheme } from '@mui/material/styles'
import { Helmet } from 'react-helmet'

export const HtmlContentStyles = () => {
  const theme = useTheme()

  const css = `
    .html-content h1, .html-content h2, .html-content h3 {
      font-family: ${theme.typography.h1.fontFamily} !important;
      color: ${theme.palette.text.primary} !important;
    }
    .html-content h4, .html-content h5, .html-content h6 {
      font-family: ${theme.typography.h4.fontFamily} !important;
      color: ${theme.palette.text.primary} !important;
    }
    .html-content p, .html-content div, .html-content li {
      font-family: ${theme.typography.body1.fontFamily} !important;
      color: ${theme.palette.text.primary} !important;
    }
    .html-content a, .html-content a:link, .html-content a:visited {
      color: ${theme.palette.primary.main} !important;
      text-decoration: underline !important;
    }
    .html-content a:hover {
      color: ${theme.palette.primary.dark || theme.palette.primary.main} !important;
    }
    .html-content blockquote {
      font-family: ${theme.typography.body1.fontFamily} !important;
      color: ${theme.palette.text.secondary} !important;
    }
    body {
      background-color: ${theme.palette.background.default};
    }
  `

  return (
    <Helmet>
      <style type="text/css">{css}</style>
    </Helmet>
  )
}
